import type {
  IResponseFiltersListSegment,
  IResponseFilterSegment,
  IOrganizationCustomFilter,
  IOrganizationFilter,
} from 'entities/Segment'
import { isCustomFieldKey } from 'entities/CustomField'
import { type FilterGroup, type FilterGroups } from 'widgets/FilterEditor/model'
import { type IFilterGroup } from 'widgets/FilterEditor/types/types'

const hubspot_keys = ['hubspot', 'hubspot-lists']

export const checkHubspotList = (groups: FilterGroups) => {
  return groups.groups.some((group) =>
    group.filters.some((filter) => hubspot_keys.includes(filter.key))
  )
}

export const getHubspotListIds = (groups: FilterGroups): number[] => {
  const hubspotListIds = new Set<number>()

  groups.groups
    .flatMap((group) => group.filters)
    .filter((filter) => hubspot_keys.includes(filter.key))
    .forEach((filter) => {
      const value = filter.payloadFilter?.value

      if (Array.isArray(value)) {
        value.forEach((hubspotListId) => {
          const id = Number(hubspotListId)
          if (!isNaN(id) && id !== 0) hubspotListIds.add(id)
        })
      } else if (value) {
        const id = Number(value)
        if (!isNaN(id) && id !== 0) hubspotListIds.add(id)
      }
    })

  return Array.from(hubspotListIds)
}

export const filterGroupsHubspot = (groups: FilterGroups, filterGroups: IFilterGroup[]) => {
  const is_hubspot = checkHubspotList(groups)
  const is_count = groups.count

  if (is_hubspot) {
    return filterGroups.filter((filterGroup) =>
      filterGroup.items.some((item) => hubspot_keys.includes(String(item.id)))
    )
  }

  if (is_count) {
    return filterGroups.filter((filterGroup) =>
      filterGroup.items.some((item) => !hubspot_keys.includes(String(item.id)))
    )
  }

  return filterGroups
}

export const groupsToSegmentFilters = (groups: FilterGroup[]): IResponseFiltersListSegment => {
  const filtersList = groups
    .filter((group) => !group.isEmpty)
    .map(({ filters }) => {
      const segment = filters.reduce<IResponseFilterSegment>(
        (segment, filter) => {
          const key = filter.key
          const payloadFilter = filter.payloadFilter

          if (isCustomFieldKey(key)) {
            const customFilter = payloadFilter as IOrganizationCustomFilter | null

            if (customFilter) segment.custom_filters.push(customFilter)
          } else if (key === 'hubspot' || key === 'hubspot-lists') {
            if (payloadFilter && Array.isArray(segment.integration_lists))
              segment.integration_lists.push({
                integration_key: key,
                list_id: payloadFilter.value as string,
              })
          } else {
            const organizationFilter = payloadFilter as IOrganizationFilter | null

            if (organizationFilter) {
              delete organizationFilter.type

              segment.filters.push(organizationFilter)
            }
          }

          return segment
        },
        {
          filters: [],
          custom_filters: [],
          filter_tags: [],
          integration_lists: [],
        }
      )

      if (!segment.integration_lists?.length) delete segment.integration_lists

      return segment
    })

  return { filtersList }
}
